export default __webpack_public_path__ + "static/media/binary-code-loading-symbol.904f2f5f.svg";